var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnBlock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.365,
    height: 15.489,
    viewBox: "0 0 12.365 15.489",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14282",
    "data-name": "Group 14282",
    transform: "translate(-337.772 -410.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11289",
    "data-name": "Path 11289",
    d: "M338.272,421.323v3.6a5.682,5.682,0,0,0,5.682,5.683h0a5.683,5.683,0,0,0,5.683-5.683v-3.6Z",
    transform: "translate(0 -5.308)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11290",
    "data-name": "Path 11290",
    d: "M342.919,414.192a3.383,3.383,0,0,1,5.774-2.393,3.417,3.417,0,0,1,.989,2.393v1.827",
    transform: "translate(-2.346)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11291",
    "data-name": "Path 11291",
    d: "M349.614,427.321a1.271,1.271,0,0,1-.627,1.541v.582a.572.572,0,0,1-.572.572h0a.572.572,0,0,1-.572-.572v-.582a1.265,1.265,0,0,1,.9-2.348A1.244,1.244,0,0,1,349.614,427.321Z",
    transform: "translate(-4.483 -7.907)",
    fill: "none",
    stroke: "var(--mainColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnBlock);
export default __webpack_public_path__ + "static/media/unBlock.f8daaebf3c8e047d3fe669eca93063b7.svg";
export { ForwardRef as ReactComponent };